"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOptionByContext = exports.options = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const resources_1 = require("../../resources");
const options = [
    {
        value: "PBP",
        body: (0, jsx_runtime_1.jsx)(resources_1.LogoPBPWithText, {}, void 0)
    },
    {
        value: "PMP",
        body: (0, jsx_runtime_1.jsx)(resources_1.LogoPMPWithText, {}, void 0)
    }
];
exports.options = options;
const getOptionByContext = (ctx = "PBP") => options.find((option) => option.value === ctx);
exports.getOptionByContext = getOptionByContext;
//# sourceMappingURL=common.js.map